import anime from 'animejs';
export const moveSmartPhoneImageAccordingtoScroll$Animation = (targetElement : HTMLElement | null, scrolledPercentage: number,isInViewPort: Boolean) => {
    if (targetElement) {
        if (isInViewPort) {
            const mt = ((scrolledPercentage - 45) * 2)
            
            if (mt >= 55 || mt <= 0) { return }
            
            anime({
                targets: [targetElement],
                marginTop: mt,
                duration:500
              });
        } else if (!isInViewPort && scrolledPercentage >= 90) {
            anime({
                targetd:  [targetElement],
                marginTop: 55,
                duration:500
              });
        }
    }
}


export const generateRotateLaptopImageAnimation = (targetElement : HTMLElement) => {
    const generatedRotateAnimation = anime({
        targets:[targetElement],
        rotate:45,
        easing: 'linear',
        duration:100,
        autoplay:false
    });

    return generatedRotateAnimation
}
export const rotateLaptopImage$Animation = (targetElement : HTMLElement | null, scrolledPercentage: number, animation :anime.AnimeInstance | null,isInViewPort : Boolean) => {
    
    if (targetElement && animation) {
        if (isInViewPort) {
            animation?.seek(scrolledPercentage - 40);
        } 
        else {
            animation?.seek(0)
        }
       
    }

}